import { render, staticRenderFns } from "./annoudetails.vue?vue&type=template&id=66c07b59&scoped=true"
import script from "./annoudetails.vue?vue&type=script&lang=js"
export * from "./annoudetails.vue?vue&type=script&lang=js"
import style0 from "./annoudetails.vue?vue&type=style&index=0&id=66c07b59&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c07b59",
  null
  
)

export default component.exports